import { APICore } from "./apiCore";

const api = new APICore()

function getForms(params: any): any {
    const baseUrl = "/formularios-internos"
    return api.get(baseUrl, params)
}

function getForm(id: String): any {
    const baseUrl = `/formularios-internos/${id}`
    return api.get(baseUrl, {})
}

function addForm(params: any): any {
    const baseUrl = "/formularios-internos"
    return api.create(baseUrl, params)
}
function updateForm(params: any): any {
    const baseUrl = "/formularios-internos"
    return api.update(baseUrl, params)
}
function deleteForm(params: any): any {
    const baseUrl = "/formularios-internos"
    return api.delete(baseUrl, params)
}

export { getForms, getForm, addForm, updateForm, deleteForm }